import Vue from 'vue'
import Router from 'vue-router'
import Print from '@/print/Print'
import PrintForm from '@/print/PrintForm'
import ParticipantDashboard from '@/pages/ParticipantDashboard'
import DashboardOrganization from '@/pages/DashboardOrganization'
import Login from '@/pages/Login'
import Admin from '@/pages/Admin'
import ManageAccount from '@/pages/ManageAccount'
import ManageUsers from '@/pages/ManageUsers'
import ViewAs from '@/pages/ViewAs'
import ReportsAdd from '@/pages/Reports/ReportsAdd'
import ReportView from "../pages/Reports/ReportView";
import ReportsList from '@/pages/Reports/ReportsList'
import ReportsTop5List from "../pages/Reports/ReportsTop5List";
import ReportEditSummary from "../pages/Reports/ReportEditSummary";
import AccountDirectory from '@/pages/AccountDirectory'
import AccountCaseMGR from '@/pages/AccountCaseMGR'
import LockScreen from '@/pages/LockScreen'
import Confirmation from '@/pages/Confirmation'
import NewPass from '@/pages/NewPass'
import Participant from '@/pages/Participant'
import ParticipantDirectory from '@/pages/ParticipantDirectory'
import ActivitiesAndServices from '@/pages/ActivitiesAndServices'
import AssessmentAndOutcomes from '@/pages/AssessmentAndOutcomes'
import Groups from '@/pages/Groups'
import GroupsForms from '@/pages/GroupsForms'
import Support from '@/pages/Support';
import Contact from '@/pages/Contact';
import Faq from '@/pages/Faq'
import Calendar from '@/pages/Calendar'
import Messages from '@/pages/Messages'
import Imports from '@/pages/Imports'
import ImportsSelect from '@/pages/ImportsSelect'
import ImportsHistory from '@/pages/ImportsHistory'
import ImportsHistorySingle from '@/pages/ImportsHistorySingle'
import Workspace from '@/pages/Workspace'
import OrganizationForms from '@/pages/OrganizationForms'
import GeneralForms from '@/pages/GeneralForms'
import WorkspaceSharedFiles from '@/pages/SharedFiles'
import GroupsMessagingHome from "../pages/Messaging/Home";
import SendMessage from "../pages/Messaging/SendMessage";
import MessagingHistoryList from "../pages/Messaging/History";
import MessagingHistoryDetails from "../pages/Messaging/HistoryDetails";
import GeneralSettings from "../pages/GeneralSettings";
import Maintenance from "../pages/Maintenance";
import FormBuilderIndex from "@/pages/FormBuilderIndex";
import FormBuilderEditor from "@/pages/FormBuilderEditor";
import EditFieldTemplate from "@/pages/EditFieldTemplate";
import EmailSettings from "../pages/EmailSettings";
import EditReferralForm from "../pages/EditReferralForm";
import ReferralDashboard from "../pages/ReferralDashboard/ReferralDashboard";
import ParticipantReferral from "../pages/ParticipantReferral";
import HelpTutorialsIndex from "../pages/HelpTutorials/HelpTutorialsIndex";
import ParticipantSharedForm from "../pages/ParticipantSharedForm";
import WorkspacePublicFiles from "../pages/PublicFiles"
import LoginTwoFactor from "../pages/LoginTwoFactor";
import {RouteName} from "../enums/routeName";

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      component: Login
    },
    {
      path: '/login-two-factor',
      component: LoginTwoFactor
    },
    {
      path: '/lock',
      component: LockScreen
    },
    {
      path: '/maintenance',
      component: Maintenance
    },
    {
      path: '/confirmation',
      component: Confirmation
    },
    {
      path: '/remind',
      name: 'Remind',
      component: Confirmation
    }, {
      path: '/remind/:token',
      name: 'Remind Token',
      component: Confirmation
    },
    {
      path: '/confirmation/:token',
      component: Confirmation
    },
    {
      path: '/newpass/:token',
      name: 'New Password',
      component: NewPass
    },
    {
      path: '/admin',
      component: Admin,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: DashboardOrganization
        },
        {
          path: 'dashboard/:id',
          name: 'Dashboard Participant',
          component: ParticipantDashboard
        },
        {
          path: 'view-as',
          name: 'View As',
          component: ViewAs
        },
        {
          path: 'manage-users',
          name: 'Manage Users',
          component: ManageUsers
        },
        {
          path: 'calendar',
          name: 'Calendar',
          component: Calendar
        },
        {
          path: 'manage-account',
          name: 'Manage Account',
          component: ManageAccount,
          children: [
            {
              path: 'list',
              name: 'Manage Account List',
              component: AccountDirectory
            },
            {
              path: 'casemgr',
              name: 'Manage Account CaseMGR',
              component: AccountCaseMGR,
              children: [
                {
                  path: 'add',
                  name: 'Manage Account Add CaseMGR',
                  component: AccountCaseMGR,
                },
                {
                  path: 'edit/:casemgrid',
                  name: 'Manage Account Edit CaseMGR',
                  component: AccountCaseMGR,
                },
                {
                  path: 'add-children/:parentid',
                  name: 'Add child account',
                  component: AccountCaseMGR,
                },
              ]
            }
          ]
        },
        {
          path: 'activities-and-services/user/:id',
          name: 'Activities and Services',
          component: ActivitiesAndServices,
          children: [
            {
              path: 'edit/:dataid',
              name: 'Activities and Services Edit',
              component: ActivitiesAndServices,
            }
          ]
        },
        {
          path: 'assessment-and-outcomes/user/:id',
          name: 'Assessment and Outcomes',
          component: AssessmentAndOutcomes,
          children: [
            {
              path: 'edit/:dataid',
              name: 'Assessment and Outcomes Edit',
              component: AssessmentAndOutcomes,
            }
          ]
        },
        {
          path: 'form-builder',
          name: 'Form Builder Index',
          component: FormBuilderIndex,
        },
        {
          path: 'form-builder/edit/:id',
          name: 'Form Builder Edit',
          component: FormBuilderEditor,
        },
        {
          path: 'field-templates/new',
          name: 'Field Template Create',
          component: EditFieldTemplate,
        },
        {
          path: 'field-templates/edit/:id',
          name: 'Field Template Edit',
          component: EditFieldTemplate,
        },
        {
          path: 'reports-index/:reset?',
          name: 'Reports Index',
          component: ReportsList,
        },
        {
          path: 'top5',
          name: 'Top 5 Reports List',
          component: ReportsTop5List
        },
        {
          path: 'reports/create',
          name: 'Reports Add',
          component: ReportsAdd
        },
        {
          path: 'reports/edit/:reportid',
          name: 'Reports Edit',
          component: ReportsAdd
        },
        {
          path: 'report/:reportid',
          name: 'Reports Preview',
          // component: ReportView,
          redirect: to => {
            return { name: 'Reports View', params: {reportid: to.params.reportid}};
          },
        },
        {
          path: 'report/:reportid/view',
          name: 'Reports View',
          component: ReportView,
        },
        {
          path: 'report/:reportid/edit-summary/:summaryId?',
          name: 'Report Summary',
          component: ReportEditSummary,
        },

        {
          path: 'participant-directory',
          name: 'Participant Directory',
          component: ParticipantDirectory,
          children: [
            {
              path: 'search/:query',
              name: 'Participant Directory Search',
              component: ParticipantDirectory
            }
          ]
        },
        // {
        //   path: 'new-participant/:cloneFrom?',
        //   name: 'Add Participant',
        //   redirect: to => {
        //     let cloneFrom = to.params.cloneFrom;
        //     return { name: 'Participant Page', params: {cloneFrom: cloneFrom}};
        //   }
        // },
        {
          path: 'participant',
          name: 'Participant Page',
          component: Participant,
          children: [
            {
              path: 'edit/:id/',
              name: 'Participant Edit',
              component: Participant
            },
            {
              path: 'edit/:id/assignment',
              name: RouteName.PARTICIPANT_ASSIGNMENT,
              component: Participant
            },
            {
              path: 'edit/:id/contact',
              name: RouteName.PARTICIPANT_CONTACT,
              component: Participant
            },
            {
              path: 'edit/:id/history/:historyid',
              name: 'Participant History',
              component: Participant
            },
            {
              path: 'clone-from/:cloneFromId',
              name: 'Participant Clone',
              component: Participant
            },
            {
              path: 'add-from-referral/:referralId',
              name: 'Add Participant from Referral',
              component: Participant
            }
          ]
        },
        {
          path: 'groups',
          name: 'Groups',
          component: Groups,
          children: [
            {
              path: 'forms',
              name: 'Groups Forms',
              component: GroupsForms
            },
            {
              path: 'messaging',
              name: 'Messaging Home',
              component: GroupsMessagingHome,
            },
            {
              path: 'send-message',
              name: 'Send Message',
              component: SendMessage
            },
            {
              path: 'history',
              name: 'Message History',
              component: MessagingHistoryList
            },
            {
              path: 'history-details/:id',
              name: 'Message History Details',
              component: MessagingHistoryDetails
            }
          ]
        },
        {
          path: 'messages/:id',
          name: 'Messages',
          component: Messages
        },
        {
          path: 'participant-referral/:id',
          name: 'Participant Referral',
          component: ParticipantReferral
        },
        {
          path: 'support',
          name: 'Support',
          component: Support,
          children: [
            {
              path: 'faq',
              name: 'FAQ',
              component: Faq
            },
            {
              path: 'contact',
              name: 'Contact',
              component: Contact
            },
            {
              path: 'help-tutorials',
              name: 'Help and Tutorials',
              component: HelpTutorialsIndex
            }
          ]
        },
        {
          path: 'imports',
          name: 'Imports',
          component: Imports
        },
        {
          path: 'imports-select',
          name: 'Imports Select',
          component: ImportsSelect
        },
        {
          path: 'imports-history',
          name: 'Imports History',
          component: ImportsHistory
        },
        {
          path: 'imports-history/:id',
          name: 'Imports History Single',
          component: ImportsHistorySingle
        },
        {
          path: 'workspace',
          name: 'Workspace',
          component: Workspace
        },
        {
          path: 'organization-forms',
          name: 'Organization Forms',
          component: OrganizationForms,
          children: [
            {
              path: 'edit/:dataid',
              name: 'Organization Forms Edit',
              component: OrganizationForms,
            }
          ]
        },
        {
          path: 'general-forms',
          name: 'General Forms',
          component: GeneralForms,
          children: [
            {
              path: 'edit/:dataid',
              name: 'General Forms Edit',
              component: GeneralForms,
            }
          ]
        },
        {
          path: 'workspace-shared-files',
          name: 'Shared files',
          component: WorkspaceSharedFiles
        },
        {
          path: 'workspace-public-files',
          name: 'Public files',
          component: WorkspacePublicFiles
        },
        {
          path: 'general-settings',
          name: 'General Settings',
          component: GeneralSettings
        },
        {
          path: 'email-settings',
          name: 'Email Settings',
          component: EmailSettings
        },
        {
          path: 'referral-dashboard/:id?',
          name: 'Referral Dashboard',
          component: ReferralDashboard
        }
      ]
    },
    {
      path: '/referral/:id',
      name: 'Edit Referral Form',
      component: EditReferralForm
    },
    {
      path: '/embed-casemgr-referral/:id',
      name: 'Embedded Referral Form',
      component: EditReferralForm
    },
    {
      path: '/form/:uid',
      name: 'Edit Participant Form',
      component: ParticipantSharedForm
    },
    {
      path: '/print',
      component: Print,
      children: [{
        path: 'form/:id',
        name: 'Print Edit',
        component: PrintForm
      }]
    },
    {
      path: '*',
      redirect: '/login'
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js